
import axios from '../../config/axiosConfig';
import { BANK_PAYMENT_RETURN_TRANSACTION_REQUEST, BANK_PAYMENT_RETURN_TRANSACTION_REQUEST_FAILURE,  GET_BANK_PAYMENT_RETURN_TRANSACTIONS } from '../types';

export const getBankPaymentReturnTransactions = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_PAYMENT_RETURN_TRANSACTION_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
            return axios.get('/bank-payment-return-transaction/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BANK_PAYMENT_RETURN_TRANSACTIONS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_PAYMENT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_PAYMENT_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
        }
    };
};